export * from '../styled';
